import React from 'react';
import classnames from 'classnames';

const THead = ({
  styles,
  cells,
}) => (
  <thead>
    <tr className={`${styles.row}`}>
      {cells.map(({ keyName, name, nowrap, wrapText, onRenderName }) => (
        <td
          key={keyName || name}
          className={classnames(styles.cell, {
            [styles.nowrap]: nowrap,
            [styles.wrapText]: wrapText,
          })}
        >
          {onRenderName ? (
            onRenderName()
          ) : (
            <div className={styles.label}>
              <span>{name}</span>
            </div>
          )}
        </td>
      ))}
    </tr>
  </thead>
);

export default THead;
